@if (report(); as report) {
  <atn-ds-page>
    <atn-ds-page-header
      [name]="reportPlugin.feature.selectors.name.asSignal()"
      [breadcrumbs]="breadcrumbsSg()"
      pageHeader
    >
      <ng-container actions>
        @if (shouldShowDownloadButtonSg()) {
          <atn-ds-button
            data-test-id="downloadButton"
            [isIcon]="true"
            [type]="PredefinedStyleEnum.White"
            [disabled]="!report.content"
            (click)="downloadClickHandler()"
          >
            <i class="atn-icon atn-download atn-blue"></i>
          </atn-ds-button>
        }
      </ng-container>

      @let reportIdx = reportIdxSg();
      <atn-ds-page-header-pagination
        [currentPage]="reportIdx === undefined ? 0 : reportIdx + 1"
        [totalPages]="numberOfPagesSg()"
        (decrement)="previousPageClickHandler()"
        (increment)="nextPageClickHandler()"
        centered
      ></atn-ds-page-header-pagination>
    </atn-ds-page-header>
    <app-report-table />
  </atn-ds-page>
}
